import { render, staticRenderFns } from "./LunchBox.vue?vue&type=template&id=1ebf3161&scoped=true"
import script from "./LunchBox.vue?vue&type=script&lang=js"
export * from "./LunchBox.vue?vue&type=script&lang=js"
import style0 from "./LunchBox.vue?vue&type=style&index=0&id=1ebf3161&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ebf3161",
  null
  
)

export default component.exports